export { default } from './RemovedIngredients';
